<script setup>
import { computed, ref } from "vue";
import { useAuthStore } from "@/app/stores/authStore";
import ImpersonationService from "@/api/services/impersonation.service";
import Notification from "@/utils/plugins/NotificationService";
import { isImpersonating, restoreOriginalSession } from "@/utils/impersonationStorage";

const authStore = useAuthStore();
const stopping = ref(false);

const active = computed(() => isImpersonating());
const targetName = computed(() => {
  const user = authStore.getUserLogged;
  return user ? `${user.name ?? ""} ${user.lastName ?? ""}`.trim() : "";
});

const stopImpersonation = async () => {
  stopping.value = true;
  try {
    await ImpersonationService.stop();
  } finally {
    // Se restaura la sesión real aunque el DELETE falle (ej. red caída) — el
    // usuario no debe quedarse atrapado en la identidad suplantada solo
    // porque el registro de auditoría del cierre no se pudo escribir.
    const restored = restoreOriginalSession();
    stopping.value = false;
    if (restored) {
      Notification.success("Suplantación finalizada.", 3000);
      window.location.reload();
    }
  }
};
</script>

<template>
  <div v-if="active" class="impersonation-banner">
    <span>Estás actuando como <b>{{ targetName }}</b></span>
    <button type="button" :disabled="stopping" @click="stopImpersonation">
      {{ stopping ? "Saliendo..." : "Salir" }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.impersonation-banner {
  align-items: center;
  background: #f9156f;
  color: #fff;
  display: flex;
  font-size: .85rem;
  font-weight: 700;
  gap: 14px;
  justify-content: center;
  left: 0;
  padding: 8px 16px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2000;
}

.impersonation-banner button {
  background: #fff;
  border: 0;
  border-radius: 15px;
  color: #f9156f;
  cursor: pointer;
  font-size: .78rem;
  font-weight: 800;
  padding: 4px 14px;
}

.impersonation-banner button:disabled {
  cursor: not-allowed;
  opacity: .6;
}
</style>
